export default {
    loading: false,
    min: true,
}